export default "__VITE_ASSET__C9jxr2zY__"